import React from 'react';
import { Link, useNavigate } from 'react-router-dom'
import useAuth from '../hooks/useAuth';
import Cookie from '../utils/Cookie';
import { useDispatch } from 'react-redux';
import { logout } from '../redux/slice/user';
import { Button } from '@mui/material';

function SiteHeader() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  // const { Logout } = useAuth();

  const handleLogout = () => {
    dispatch(logout())
  }

  return (
    // <div className="authHeader">
    //   <div className="custom-container">
    //     <div className="authHeader-wrapper">
    //       <div className="authHeader_logo">
    //         {/* <button onClick={() => { navigate('/') }}>
    //           HOME
    //         </button> */}
    //       </div>
    //       <div className="authHeader_rg">
    //         <ul className="authHeader_nav">
    //           {/* {Cookie.getCookie('_tokenAuth') ?
    //             <li className="signIn">
    //               <a onClick={() => { handleLogout(); navigate('/login') }}>Logout</a>
    //             </li>
    //             :
    //             <li className="signIn">
    //               <button onClick={() => { navigate('/login') }} className="custom-btn-skyblue">
    //                 Sign In</button></li>
    //           } */}
    //         </ul>
    //       </div>
    //     </div>
    //   </div>
    // </div>
    <header className="fixed top-0 left-0 right-0 z-50">
      <div className="absolute inset-0 bg-background/60 backdrop-blur-2xl border-b border-border/30" />
      <div className="container relative mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <div className="w-10 h-10 rounded-xl  flex items-center justify-center transition-shadow">
              <img src="/favicon.ico" className='rounded-full' alt="" />
          </div>
          <span className="text-xl font-semibold text-foreground tracking-tight">Syntimacy</span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <a href="#features" className="text-foreground/60 hover:text-foreground transition-colors text-sm font-medium">Features</a>
          <Link to="/how-it-works" className="text-foreground/60 hover:text-foreground transition-colors text-sm font-medium">How it Works</Link>
          <Link to="/creators" className="text-foreground/60 hover:text-foreground transition-colors text-sm font-medium">For Creators</Link>
        </nav>

        <div className="flex items-center gap-4">
          <Link to="/login">
            <button type="button" className="theme-transparent-btn !text-xs !h-[36px] !px-3">
              Sign In
            </button>
          </Link>
          <Link to="/register">
            <button type="button" className="theme-solid-btn !text-xs !h-[36px] !px-3">Get Started</button>
          </Link>
        </div>
      </div>
    </header>
  );
}

SiteHeader.propTypes = {};

export default SiteHeader;
